import "@arco-design/web-react/es/List/style";
import _List from "@arco-design/web-react/es/List";
import "@arco-design/web-react/es/Tag/style";
import _Tag from "@arco-design/web-react/es/Tag";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Typography/style";
import _Typography from "@arco-design/web-react/es/Typography";
import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Result/style";
import _Result from "@arco-design/web-react/es/Result";
import React from 'react';
import useLocale from '../../utils/useLocale';
import styles from './style/index.module.less';
function MessageList(props) {
  const t = useLocale();
  const {
    data,
    unReadData
  } = props;
  function onItemClick(item, index) {
    if (item.status) return;
    props.onItemClick && props.onItemClick(item, index);
  }
  function onAllBtnClick() {
    props.onAllBtnClick && props.onAllBtnClick(unReadData, data);
  }
  return /*#__PURE__*/React.createElement(_List, {
    noDataElement: /*#__PURE__*/React.createElement(_Result, {
      status: "404",
      subTitle: t['message.empty.tips']
    }),
    footer: /*#__PURE__*/React.createElement("div", {
      className: styles.footer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['footer-item']
    }, /*#__PURE__*/React.createElement(_Button, {
      type: "text",
      size: "small",
      onClick: onAllBtnClick
    }, t['message.allRead'])), /*#__PURE__*/React.createElement("div", {
      className: styles['footer-item']
    }, /*#__PURE__*/React.createElement(_Button, {
      type: "text",
      size: "small"
    }, t['message.seeMore'])))
  }, data.map((item, index) => /*#__PURE__*/React.createElement(_List.Item, {
    key: item.id,
    actionLayout: "vertical",
    style: {
      opacity: item.status ? 0.5 : 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: 'pointer'
    },
    onClick: () => {
      onItemClick(item, index);
    }
  }, /*#__PURE__*/React.createElement(_List.Item.Meta, {
    avatar: item.avatar && /*#__PURE__*/React.createElement(_Avatar, {
      shape: "circle",
      size: 36
    }, /*#__PURE__*/React.createElement("img", {
      src: item.avatar
    })),
    title: /*#__PURE__*/React.createElement("div", {
      className: styles['message-title']
    }, /*#__PURE__*/React.createElement(_Space, {
      size: 4
    }, /*#__PURE__*/React.createElement("span", null, item.title), /*#__PURE__*/React.createElement(_Typography.Text, {
      type: "secondary"
    }, item.subTitle)), item.tag && item.tag.text ? /*#__PURE__*/React.createElement(_Tag, {
      color: item.tag.color
    }, item.tag.text) : null),
    description: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Typography.Paragraph, {
      style: {
        marginBottom: 0
      },
      ellipsis: true
    }, item.content), /*#__PURE__*/React.createElement(_Typography.Text, {
      type: "secondary",
      style: {
        fontSize: 12
      }
    }, item.time))
  })))));
}
export default MessageList;